"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidBirthdateRange = exports.getInclusiveMinAgeDateTimestamp = exports.getDaysSinceBirth = exports.getDateComponent = exports.ValidateBirthdate = exports.IsDateEntryComplete = exports.GetMinAndMaxAges = exports.GetMinAge = exports.GetMaxAge = exports.GetAgeInYears = exports.GetAgeInWeeks = void 0;
require("core-js/modules/es.symbol.description.js");
var _dateHelpers = require("./dateHelpers");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Get the date component of a date without the time component
 * @param refDate {Date} The reference date
 * @returns {Date} The date component of the date
 */
const getDateComponent = refDate => {
  return new Date(refDate.getFullYear(), refDate.getMonth(), refDate.getDate());
};

/**
 *
 * @param minAgeInDays
 * @param refDate
 * @returns {{isoMinDate: (*|Date), minDate: Date, minDateTimestamp: number}} The returned minDate should have only
 * the date component with the time set to 00:00:00 in local time
 * @constructor
 */
exports.getDateComponent = getDateComponent;
const GetMinAge = _ref => {
  let {
    minAgeInDays,
    refDate = new Date()
  } = _ref;
  const date = getDateComponent(refDate);
  date.setDate(date.getDate() - minAgeInDays);
  return {
    minDate: date,
    minDateTimestamp: date.getTime(),
    isoMinDate: (0, _dateHelpers.DateToShortIsoString)(date)
  };
};

/**
 *
 * @param maxAgeInDays
 * @param refDate
 * @returns {{maxDate: Date, maxDateTimestamp: number, isoMaxDate: (*|Date)}} The returned maxDate should have only
 * the date component with the time set to 00:00:00 in local time
 * @constructor
 */
exports.GetMinAge = GetMinAge;
const GetMaxAge = _ref2 => {
  let {
    maxAgeInDays,
    refDate = new Date()
  } = _ref2;
  const date = getDateComponent(refDate);
  date.setDate(date.getDate() - maxAgeInDays);
  return {
    maxDate: date,
    maxDateTimestamp: date.getTime(),
    isoMaxDate: (0, _dateHelpers.DateToShortIsoString)(date)
  };
};

/**
 * Get the minimum and maximum ages
 * @param {number} minAgeInDays The minimum age in days
 * @param {number} maxAgeInDays The maximum age in days
 * @param {Date} refDate The reference date
 * @returns {{isoMinDate: (*|Date), minDate: Date, maxDate: Date, maxDateTimestamp: number, isoMaxDate: (*|Date), minDateTimestamp: number}}
 * The returned minDate and maxDate should have only
 * @constructor
 */
exports.GetMaxAge = GetMaxAge;
const GetMinAndMaxAges = _ref3 => {
  let {
    minAgeInDays,
    maxAgeInDays,
    refDate = new Date()
  } = _ref3;
  const beginningOfDay = new Date(refDate.getFullYear(), refDate.getMonth(), refDate.getDate());
  // If a refDate is passed in make a new date object to ensure a clean date object each time
  return _objectSpread(_objectSpread({}, GetMinAge({
    minAgeInDays,
    refDate: new Date(beginningOfDay.getTime())
  })), GetMaxAge({
    maxAgeInDays,
    refDate: new Date(beginningOfDay.getTime())
  }));
};

/**
 * Validates the birthdate of the owner to ensure it is within the minimum and maximum age limits.
 *
 * @param {string} date The birthdate of the owner.
 * @param {number} minAgeTimeStamp The date of minimum age timestamp
 * @param {number} maxAgeTimeStamp The date of maximum age timestamp
 * @param {number} minAgeInDays The minimum age in days
 * @param {function} clearErrors The function to clear errors
 * @param {string} name The name of the field
 * @returns {null|string} Returns true if the birthdate is valid, otherwise returns an error message
 */
exports.GetMinAndMaxAges = GetMinAndMaxAges;
const isValidBirthdateRange = (date, minAgeTimeStamp, maxAgeTimeStamp, minAgeInDays, clearErrors, name) => {
  const dateValue = new Date(date);
  const dateValueTimeStamp = dateValue.getTime();
  if (dateValueTimeStamp >= minAgeTimeStamp) {
    return "Your pet must be ".concat(Math.round(minAgeInDays / 7), " weeks of age or older.");
  }
  if (dateValueTimeStamp < maxAgeTimeStamp) {
    return 'We\'re sorry, we can\'t start cover for your pet. There is a maximum entry age for new policies.';
  }
  clearErrors(name);
  return null;
};

/**
 * Validates the birthdate of the owner to ensure it is within the minimum and maximum age limits.
 * @param minDateTimestamp {number} The date of minimum age timestamp
 * @returns {number} The date of minimum age timestamp
 */
exports.isValidBirthdateRange = isValidBirthdateRange;
const getInclusiveMinAgeDateTimestamp = minDateTimestamp => {
  let minAgeDateTimestamp = minDateTimestamp;
  if (minAgeDateTimestamp) {
    const minAgeDate = getDateComponent(new Date(minDateTimestamp));
    minAgeDate.setDate(minAgeDate.getDate() + 1); // Add one day to the min age date to make it inclusive
    minAgeDateTimestamp = minAgeDate.getTime();
  }
  return minAgeDateTimestamp;
};

/**
 * Validates the birthdate of the owner to ensure it is within the minimum and maximum age limits.
 * @param birthdateString {string} The birthdate of the owner.
 * @param minDateTimestamp {number} The date of minimum age timestamp
 * @param maxDateTimestamp {number} The date of maximum age timestamp
 * @returns {{maxDateValid: boolean, minDateValid: boolean}} Returns true if the birthdate is valid, otherwise returns an error message
 * @constructor ValidateBirthdate
 */
exports.getInclusiveMinAgeDateTimestamp = getInclusiveMinAgeDateTimestamp;
const ValidateBirthdate = _ref4 => {
  let {
    birthdateString,
    minDateTimestamp,
    maxDateTimestamp
  } = _ref4;
  const birthdate = new Date(birthdateString);
  const birthdateTimestamp = birthdate.getTime();
  const validStates = {
    minDateValid: true,
    maxDateValid: true
  };
  if (minDateTimestamp) {
    const startOfDateMinAge = new Date(minDateTimestamp);
    const startOfDateMinAgeTimestamp = getDateComponent(startOfDateMinAge).getTime();

    // Note minDate is an age so if the birthdate
    // is after it on a timescale it is considered younger
    // hence the greater than check
    if (typeof startOfDateMinAgeTimestamp === 'number' && birthdateTimestamp > startOfDateMinAgeTimestamp) {
      validStates.minDateValid = false;
    }
  }
  if (maxDateTimestamp) {
    const startOfDateMaxAge = new Date(maxDateTimestamp);
    const startOfDateMaxAgeTimestamp = getDateComponent(startOfDateMaxAge).getTime();
    // For the maxDate the converse of the above logic is true
    // Also cater for timestamps before Jan 1 1970 that will be negative values
    if (typeof maxDateTimestamp === 'number' && (birthdateTimestamp < startOfDateMaxAgeTimestamp || startOfDateMaxAgeTimestamp < 0 && startOfDateMaxAgeTimestamp > birthdateTimestamp)) {
      validStates.maxDateValid = false;
    }
  }
  return validStates;
};

/**
 * Validates the birthdate of the owner to ensure it is within the minimum and maximum age limits.
 * @param {string} dateString The birthdate of the owner.
 * Format: 'yyyy-mm-dd' or any format that is supported by new Date(dateString)
 * @returns {boolean} Returns true if the birthdate is valid, otherwise returns an error message
 * @constructor
 */
exports.ValidateBirthdate = ValidateBirthdate;
const IsDateEntryComplete = _ref5 => {
  let {
    dateString
  } = _ref5;
  const refDate = new Date(dateString);
  return refDate.getFullYear() >= 1000;
};
exports.IsDateEntryComplete = IsDateEntryComplete;
const GetAgeInWeeks = _ref6 => {
  let {
    ageInDays
  } = _ref6;
  return Math.round(ageInDays / 7);
};
exports.GetAgeInWeeks = GetAgeInWeeks;
const GetAgeInYears = _ref7 => {
  let {
    ageInDays
  } = _ref7;
  return Math.round(ageInDays / 365.25);
};

/**
 * Converts date string to the number of days since birth
 * @param {string} dateString the date to be converted
 * @returns {number} returns the age in days
 */
exports.GetAgeInYears = GetAgeInYears;
const getDaysSinceBirth = exports.getDaysSinceBirth = function getDaysSinceBirth(dateString) {
  let currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (!dateString) throw new Error('Date is required');
  const birthdate = new Date(dateString);
  if (Number.isNaN(birthdate.getTime())) throw new Error('Invalid date format');
  if (birthdate > currentDate) throw new Error('Birthdate cannot be in the future');
  const diffTime = currentDate - birthdate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};